export default {"src":"/_next/static/media/flux.a132612e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};